import Controller from '@ember/controller';
import { action } from '@ember/object';
import { service } from '@ember/service';
import type ReactRendererService from 'garaje/services/react-renderer';
import type StateService from 'garaje/services/state';
import type { Root } from 'react-dom/client';

export default class LocationOverviewPoliciesEditController extends Controller {
  @service declare reactRenderer: ReactRendererService;
  @service declare state: StateService;

  declare model: string;

  private root?: Root;

  @action
  async injectComponent(): Promise<void> {
    const { UpdateDraftPolicy } = await import('reactRichComponents/visitors/UpdateDraftPolicy');

    this.root = await this.reactRenderer.render(UpdateDraftPolicy, 'react__visitors__settings__policies__update', {
      policyId: this.model,
      companyId: this.state.currentCompany?.id,
    });
  }

  @action
  destroyComponent(): void {
    if (this.root) {
      this.reactRenderer.unmount(this.root);
      this.root = undefined;
    }
  }
}
